import { BaseTranslationsLoader } from "./base-translations.loader";
export class BaseConfigurableTranslationsLoader extends BaseTranslationsLoader {
    constructor(localizationService, options) {
        super(localizationService);
        this.options = {};
        if (options) {
            this.configure(options);
        }
        else {
            this.options = this.getDefaultOptions();
        }
    }
    configure(options) {
        this.validateOptions(options);
        this.options = options || this.getDefaultOptions();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS1jb25maWd1cmFibGUtdHJhbnNsYXRpb25zLmxvYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvbG9jYWxpemF0aW9uL3RyYW5zbGF0aW9ucy9sb2FkZXJzL2Jhc2UtY29uZmlndXJhYmxlLXRyYW5zbGF0aW9ucy5sb2FkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUEsT0FBTyxFQUFDLHNCQUFzQixFQUFDLE1BQU0sNEJBQTRCLENBQUM7QUFFbEUsTUFBTSxPQUFnQixrQ0FBNkMsU0FBUSxzQkFBc0I7SUFHN0YsWUFBc0IsbUJBQXlDLEVBQUUsT0FBa0I7UUFDL0UsS0FBSyxDQUFDLG1CQUFtQixDQUFDLENBQUM7UUFIckIsWUFBTyxHQUFhLEVBQWMsQ0FBQztRQUt6QyxJQUFJLE9BQU8sRUFBRTtZQUNULElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLENBQUM7U0FDM0I7YUFBTTtZQUNILElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDLGlCQUFpQixFQUFFLENBQUM7U0FDM0M7SUFDTCxDQUFDO0lBRVMsU0FBUyxDQUFDLE9BQWtCO1FBQ2xDLElBQUksQ0FBQyxlQUFlLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDOUIsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLElBQUksSUFBSSxDQUFDLGlCQUFpQixFQUFFLENBQUM7SUFDdkQsQ0FBQztDQUtKIn0=